import { Injectable, OnDestroy } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { CompanyDTO } from '../../api/plyca-dtos-v2';
import { Observable } from 'rxjs';
import { DaciExtDTO } from './daciExtDTO';
import { Configuration } from '../../conf/app.constants';
import { BaseDirectiveObject } from '../../components/common/base-directive-object';

@Injectable({
  providedIn: 'root'
})
export class DaciExtService extends BaseDirectiveObject implements OnDestroy {


  public DACI_SERVICE_URL; // = this.UserApiUrl + 'v2' + this.COMPANY_NAME_URL;

  constructor(
    private plycaService: PlycaDataService,
    protected configuration: Configuration) {
    super();

  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  query(projec: string): Observable<any> {

    let filter = {} as any;
    filter.projectEntityIdentifier = projec;
    // filter.excludeDisabled = true;
    /*filter.expand = 'expansionSet:COLLECTION';*/

    return this.plycaService.query<DaciExtDTO>(this.getServiceURL(), filter);
  }

  insert(row: DaciExtDTO): Observable<any> {
    console.log('DaciExtDTO', row);
    return this.plycaService
      .insert<DaciExtDTO>(
        this.getServiceURL(),
        row
      );
  }

  update(row: DaciExtDTO): Observable<any> {
    console.log('DaciExtDTO', row);
    return this.plycaService
      .update<DaciExtDTO>(
        this.getServiceURL(), row);
  }

  getServiceURL(): string {
    return this.configuration.UserApiUrl + this.configuration.ApiVersion + 'daciexts/';

  }

  new(dossierID: string): Observable<any> {

    return this.plycaService.get<any>(this.getServiceURL(), 'new',
      {
        projectId: dossierID,
      }
    );


  }

  remove(row: DaciExtDTO): Observable<any> {
    return this.plycaService.delete(this.getServiceURL(), row.identifier);

  }

}
